import { ShareArtButtonController } from './share-art-button.controller'

/* @ngInject */
function shareArtButton () {
  return {
    restrict: 'E',
    templateUrl: '/core/directives/share-art-button/share-art-button-directive.html?$$REVISION$$',
    controller: ShareArtButtonController,
    scope: {
      art: '<',
      location: '<',
      contextData: '<',
      disable: '<',
      isEditor: '<',
      onClose: '<',
      onSaveArt: '<'
    }
  }
}

export { shareArtButton }
